import { VersesModel } from "./verses-model"

export class VersetDuJourModel
{
  id: string='';
  bookOsis: string='';
  verset: string='';
  dateDeclancheur: string='';
  actifYN: boolean= true;
  dateModif: string='';
  dateCreated: string='';
  versesData: VersesModel= new VersesModel();
}

export enum VersetDuJourTextField
{
  title= 'Verset du jour',
  id= 'Id',
  bookOsis= 'Book Osis',
  verset='verset',
  actifYN='Actif (Y/N)',
  dateDeclancheur='Date Declancheur',
  dateModif='Date Modif',
  dateCreated='Date Created',
}
